const v2 = {
  page_loader_errors: {
    failed_to_load_dependencies: 'ページ内容の読み込み中にエラーが発生しました',
    unspecified: 'おっと!何かがおかしくなった',
    unauthorized: '無許可。',
    unauthenticated: '認証が必要。',
    no_domain_policy_access: 'アクセスが拒否'
  },
  field_errors: {
    invalid_value: '無効な値',
    required_value: '必須値',
    invalid_email: '無効なメールアドレス',
    email_domain_not_allowed: 'メールアドレスは、あなたが管理するドメインに属するものでなければなりません。',
    outbound_email_ids_required: '管理者用隔離通知アドレスを必ずご提供ください。'
  }
}

export default v2
